import { Controller } from "@hotwired/stimulus"

// Muestra el hint según documents_action. El `change` lo recibe Stimulus vía data-action (HTML).
export default class extends Controller {
  static targets = ["blockHint", "removeHint"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasBlockHintTarget || !this.hasRemoveHintTarget) return

    const selected = this.element.querySelector(
      'input[type="radio"][name*="documents_action"]:checked'
    )

    const value = selected?.value ?? "block"

    if (value === "remove") {
      this.blockHintTarget.classList.add("d-none")
      this.removeHintTarget.classList.remove("d-none")
    } else {
      this.blockHintTarget.classList.remove("d-none")
      this.removeHintTarget.classList.add("d-none")
    }
  }
}
